import { Nullable } from 'utils/types';
import { CaseResponse } from 'modules/cm/api/cases/types';
import { BUSINESS_TYPES } from 'modules/cm/domain/Case/Applicant/Income/Current/Current';

export type CurrentIncome = {
  currentIncomeEmployedTotal: Nullable<number>;
  currentIncomeSelfEmployedTotal: Nullable<number>;
  currentIncomeOtherTotal: Nullable<number>;
  currentIncomeTotal: Nullable<number>;
  currentIncomePensionIncome: Nullable<number>;
  currentIncomeBasicGrossAnnualSalary: Nullable<string>;
  currentIncomeAnnualBonus: Nullable<string>;
  currentIncomeHasAnnualBonusGuaranteed: Nullable<boolean>;
  currentIncomeAnnualCommission: Nullable<string>;
  currentIncomeHasCommissionGuaranteed: Nullable<boolean>;
  currentIncomeAnnualOvertime: Nullable<string>;
  currentIncomeHasOvertimeGuaranteed: Nullable<boolean>;
  currentIncomeAnnualShiftAllowance: Nullable<string>;
  currentIncomeHasShiftAllowanceGuaranteed: Nullable<boolean>;
  currentIncomeBusinessType: Nullable<BUSINESS_TYPES>;
  currentIncomePercentageOfBusinessOwned: Nullable<string>;
  currentIncomeLimitedCompanySalary: Nullable<string>;
  currentIncomeLimitedCompanyDividends: Nullable<string>;
  currentIncomeNetProfit: Nullable<string>;
  currentIncomeBusinessTradingDate: Nullable<string>;
  currentIncomeInvestmentIncomes: InvestmentIncome[];
  currentIncomeRentalIncomes: RentalIncome[];
  currentIncomeFosteringIncomes: FosteringIncome[];
  currentIncomeMaintenanceIncomes: MaintenanceIncome[];
  currentIncomeBenefitIncomes: BenefitIncome[];
  currentIncomeOtherIncomes: OtherIncome[];
};

export type InvestmentIncome = {
  id: number;
  investmentPortfolioValue: Nullable<string>;
  annualInvestmentIncome: Nullable<string>;
  annualDividendIncome: Nullable<string>;
};

export type RentalIncome = {
  id: number;
  grossAnnualRentalIncome: Nullable<string>;
  noOfBtlsInPortfolio: Nullable<string>;
  mortgagePayment: Nullable<string>;
};

export type FosteringIncome = {
  id: number;
  grossAnnualFosteringIncome: Nullable<string>;
};

export type MaintenanceIncome = {
  id: number;
  grossAnnualMaintenanceIncome: Nullable<string>;
  hasMaintenanceGuaranteedOtherIncome: Nullable<boolean>;
};

export type BenefitIncome = {
  id: number;
  grossAnnualBenefitIncome: Nullable<string>;
  hasBenefitGuaranteedOtherIncome: Nullable<boolean>;
};

export type OtherIncome = {
  id: number;
  grossAnnualOtherIncome: Nullable<string>;
  hasBonusGuaranteedOtherIncome: Nullable<boolean>;
};

export type PatchResponse = CaseResponse;

export enum INCOME_TYPES {
  INVESTMENT = 'investment',
  RENTAL = 'rental',
  OTHER = 'other',
  FOSTERING = 'fostering',
  MAINTENANCE = 'maintenance',
  BENEFIT = 'benefit',
}
